import { InjectionToken } from '@angular/core';
import { IDictionaryProviderService } from './dictionary-provider.interface';

export const DICTIONARY_PROVIDER: InjectionToken<IDictionaryProviderService> = new InjectionToken(
  'core.dictionary.provider',
);
